import { cn } from "@/lib/cn";

export interface CawambaMarkProps {
  className?: string;
  /** Inline title for screen readers. Pass `null` to mark decorative. */
  title?: string | null;
}

/**
 * Cawamba glyph: an open "C" arc with the accent dot tucked into its mouth.
 *
 * - The arc inherits color from `currentColor` (parent's `text-*`).
 * - The dot uses `var(--accent)` so it pops against the arc regardless of
 *   the surrounding text color.
 * - Designed on a 32x32 grid, square aspect ratio. Scale via `className`
 *   (e.g. `h-7 w-7`, `h-8 w-8`).
 *
 * Reads as both the "C" of Cawamba and an eye-with-pupil — a nod to the
 * watch-only nature of the app.
 */
export function CawambaMark({
  className,
  title = "Cawamba",
}: CawambaMarkProps) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      aria-label={title ?? undefined}
      className={cn("inline-block", className)}
    >
      <path
        d="M21 7 A10 10 0 1 0 21 25"
        stroke="currentColor"
        strokeWidth="2.75"
        strokeLinecap="round"
      />
      <circle cx="21.5" cy="16" r="2.4" fill="var(--accent)" />
    </svg>
  );
}
